import React, { useContext } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { StatusBar } from "expo-status-bar";
import Logo from "../../../assets/logo-gpx-ecofi.png";
import { FormattedMessage } from "react-intl";
import styles from "./style";
import { LanguageContext } from "../../context/LanguageContext";
import LanguageSelector from "../../components/LanguageSelector";

export default function Welcome({ navigation }) {
  function handlePressedButton(route) {
    navigation.navigate(route, { lang });
  }

  const { lang } = useContext(LanguageContext);
  /*   const { lang, changeLanguage } = useContext(LanguageContext);
   */
  return (
    <View style={styles.container}>
      <LinearGradient
        start={{ x: 1, y: 0.99 }}
        end={{ x: 1, y: 1 }}
        colors={["#077A97", "#A3CED8"]}
        style={{ width: "100%", alignItems: "center", flex: 1 }}
      >
        <Image
          style={{ width: 200, height: 200, marginVertical: "10%" }}
          source={Logo}
        />

        <LanguageSelector />

        <View style={styles.loginContainer}>
          <TouchableOpacity
            onPress={() => handlePressedButton("Login")}
            style={[styles.button, styles.loginButton]}
          >
            <Image source={Logo} />
            <Text style={[styles.text, { color: "#FFF" }]}>
              <FormattedMessage id="welcome.entrar" />
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => handlePressedButton("Register")}
            style={{
              backgroundColor: "",
              width: 350,
              height: 60,
              borderRadius: 4,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={[styles.text, { color: "#FFF" }]}>
              <FormattedMessage id="welcome.criar" />
            </Text>
          </TouchableOpacity>
        </View>

        <StatusBar style="light"></StatusBar>
      </LinearGradient>
    </View>
  );
}
